import Logger from '@medflex/utils/Logger';
import { SUBSCRIPTION_PLANS } from '@medflex/utils/subscriptionEnums';
import createUpgradeUrl from '@medflex/utils/createUpgradeUrl';
import { UPGRADE_SUBSCRIPTION_PACKAGE_URL } from '../../constants';

export const NAME = 'subscription';

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  FAILED: 'failed',
  LOADED: 'loaded',
};

const onLoaded = (state, { features, ...data }) => {
  // exposes subscription, so it can be used for AB tests
  const { plan, email, trialEndedAt } = data;
  try {
    localStorage.setItem(NAME, JSON.stringify({ plan, features, trialEndedAt }));
  } catch (e) {
    Logger.warn(`Couldn't store subscription in local storage: ${e.message}`);
  }

  const hasUpgradeOptions =
    ![SUBSCRIPTION_PLANS.ENTERPRISE, SUBSCRIPTION_PLANS.PROFESSIONALPLUS].includes(plan) ||
    trialEndedAt;

  const upgradeUrl = hasUpgradeOptions
    ? createUpgradeUrl({
        baseUrl: UPGRADE_SUBSCRIPTION_PACKAGE_URL,
        plan,
        email,
      })
    : null;

  return {
    ...state,
    status: STATUS.LOADED,
    error: null,
    features,
    upgradeUrl,
    ...data,
  };
};

const subscription = {
  name: NAME,
  state: {
    status: STATUS.IDLE,
    features: null,
    plan: null,
    error: null,
  },
  reducers: {
    onLoaded,
    'superuser/setUserProfile': (state, { attributes }) =>
      onLoaded(state, attributes.subscription || {}), // it is important to pass the empty object if there is no subscription, this fixes MMA-358
  },
  messageListeners: {
    'subscriptions:subscription_changed': function subscriptionChanged({ payload }) {
      this.onLoaded(payload);
    },
  },
};

export default subscription;
